import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const ROUTERBLOCK_LEGACY_FIELD_ORDER = [];

const {
  routerBlockDescriptor: _generatedRouterBlockDescriptor,
  routerBlockBlocDefinition,
  routerBlockDashboardLayout,
  routerBlockConfig,
  routerBlockResolveConfig,
  routerBlockProperties,
} = doodBlockConfig(
  {
    name: "Router block",
    componentType: 'RouterBlockComponent',
    category: 'system',
    description: "Router block.",
    keywords: [],
    sharedFields: {}
  },

  () => ({
    // no scalar props
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: [],
          },
        ],
      },
    ],
  })
);

export function routerBlockDescriptor(): IBlockDescriptor;
export function routerBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function routerBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedRouterBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedRouterBlockDescriptor, routerBlockProperties, fieldOrder);
}

export {
  routerBlockBlocDefinition,
  routerBlockDashboardLayout,
  routerBlockProperties,
  routerBlockConfig,
  routerBlockResolveConfig,
};

export type RouterBlockConfig = typeof routerBlockConfig;
